/* Branded microsite URL helpers.
   Every organizer has a permanent branded path (/{organizer-slug}); events live
   under /{organizer-slug}/{event-slug}. Legacy /e/{slug} URLs keep working and
   redirect (replace) to the branded path once the payload reveals the slug.
   Fase E1: bajo un dominio personalizado conectado, las rutas del organizador
   viven en la raíz del dominio (sin prefijo de slug). */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { getHostTenant } from "@/lib/hostTenant";

export const eventBase = (orgSlug, eventSlug) => {
  const tenant = getHostTenant();
  if (tenant && orgSlug && orgSlug === tenant.slug) return `/${eventSlug}`;
  return orgSlug ? `/${orgSlug}/${eventSlug}` : `/e/${eventSlug}`;
};

export function useBrandedRedirect(orgSlug, eventSlug) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!orgSlug || !eventSlug) return;
    const legacy = `/e/${eventSlug}`;
    if (location.pathname === legacy || location.pathname.startsWith(`${legacy}/`)) {
      navigate(
        location.pathname.replace(legacy, eventBase(orgSlug, eventSlug)) + location.search + location.hash,
        { replace: true }
      );
    }
  }, [orgSlug, eventSlug, location.pathname, location.search, location.hash, navigate]);
}
